import { BridgeComponent, BridgeElement } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "form"
  static targets = ["submit"]

  submitTargetConnected(target) {
    const submitButton = new BridgeElement(target)
    const title = submitButton.title

    this.send("connect", { title }, () => {
      target.click()
    })
  }

  submitStart() {
    this.send("submitDisabled")
  }

  submitEnd() {
    this.send("submitEnabled")
  }
}
